import type * as lazyIndex from './lazyIndex';
export { default as loadTableViewFromTableQuery } from './actions/loadTableViewFromTableQuery';
export { setTableViewErrorState } from './actions/onInitialTableLoadComplete';
export { default as onInitialTableLoadComplete } from './actions/onInitialTableLoadComplete';
import './orchestrators/loadTableViewFromSearchTableQueryOrchestrator';
import './orchestrators/loadMessageSuggestionIntoTableOrchestrator';
import './orchestrators/selectFocusedViewFilterOrchestrator';
import './orchestrators/initializeLazyImports';
import { onListViewTypeOptionSaved } from 'owa-options-actions/lib/onListViewTypeOptionSaved';

import { LazyModule, LazyAction, registerLazyOrchestrator } from 'owa-bundling';
const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName:"TableLoading" */ './lazyIndex'),
    { name: 'mail/packages/mail/orchestration/owa-mail-table-loading-actions' }
);

registerLazyOrchestrator(
    onListViewTypeOptionSaved,
    lazyModule,
    m => m.onListViewTypeOptionSavedOrchestrator
);

export const lazyLoadCopilotCatchUpFilter: LazyAction<
    typeof lazyIndex.loadCopilotCatchUpFilter,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.loadCopilotCatchUpFilter);
